export default __webpack_public_path__ + "static/media/Hjulet.e4658a42.svg";